module.exports = __webpack_public_path__ + "static/media/UB.5399c1ee.svg";